// BlockedScreen.jsx -- onboarding step `blocked`. Single job: tell an under-21 user they cannot use
// SlipTrack, offer help and support. No countdown, no deletion action (D3).
import { shell, headline, body, ghostBtn, spacer, C } from './onboardingStyles';
import HelplineCard from '../../components/ui/HelplineCard';
export default function BlockedScreen({ signedIn, onSignOut }) {
  return (
    <div style={shell}>
      <div style={{ fontSize: 11, fontWeight: 800, letterSpacing: 4, color: C.dim }}>SLIPTRACK</div>
      <div style={{ marginTop: 72, display: 'flex', flexDirection: 'column', gap: 14 }}>
        <h1 style={headline}>SlipTrack is for adults 21 and older</h1>
        <p style={{ ...body, fontSize: 16 }}>You can't use SlipTrack right now.</p>
      </div>
      <p style={{ ...body, marginTop: 36, fontSize: 14, color: C.bright }}>If gambling is affecting you or someone you know, free and confidential help is available any time.</p>
      <div style={{ marginTop: 10 }}><HelplineCard /></div>
      <div style={spacer} />
      <div style={{ fontSize: 13, color: C.secondary, textAlign: 'center', marginBottom: 16 }}>Entered the wrong date? Email <a href="mailto:hello@sliptrack.net" style={{ display: 'inline-flex', alignItems: 'center', minHeight: 44, color: C.primary, fontWeight: 600 }}>hello@sliptrack.net</a></div>
      {signedIn && <button type="button" style={ghostBtn} onClick={onSignOut}>Sign out</button>}
    </div>
  );
}
